import { CLIENT_ROUTES } from "@/app/router/constants";
export const buildUrlPatterns = (urlPatterns) => {
    const urlPatternsWithRoutes = urlPatterns
        .map((pattern) => {
        const clientRoutePatterns = Object.values(CLIENT_ROUTES).map((clientRoute) => `${pattern}/${clientRoute}`);
        return [pattern, ...clientRoutePatterns];
    })
        .flat();
    return urlPatternsWithRoutes;
};
